import React, { useState } from "react";
import dayjs from "dayjs";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip,
  Stack,
  styled,
  CircularProgress,
  Link,
  Typography,
  MenuItem,
  Select,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  InfoRounded,
  Unsubscribe,
  Visibility,
  ContentCopy,
} from "@mui/icons-material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { useTheme } from "@mui/system";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";



export const DomainCell = ({
  field,
  value,
  domain,
  themeId,
  showWarning,
  onCopy,
  hoverIndex,
  index,
  hoverField,
  theme,
}) => (

  <Stack direction="row" alignItems="center">

    {showWarning && (
      <InfoRounded
        style={{ fontSize: "15px" }}
        sx={{ mr: 0.5, color: "#F59815" }}
      />
    )}
    <Typography className="typography hover">{value}</Typography>

    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{
        opacity: `${index === hoverIndex && hoverField === field ? 1 : 0}`,
        pointerEvents:
          index === hoverIndex && hoverField === field ? "auto" : "none",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffffff",
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #f1f1f1",
          color: "black",
          cursor: onCopy ? "pointer" : "default",
          opacity: onCopy ? 1 : 0,
          pointerEvents: onCopy ? "auto" : "none",
        }}
      >
        <ContentCopy
          style={{ fontSize: "13px" }}
          sx={{ color: "#000000" }}
          onClick={() => onCopy(value)}
        />
      </Box>

      <Link
        href={`https://${domain}/?preview_theme_id=${themeId}`}
        target="_blank"
        sx={{
          backgroundColor: "#ffffffff",
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #f1f1f1",
          color: "black",
          cursor: field !== "email" ? "pointer" : "default",
          opacity: field !== "email" ? 1 : 0,
          pointerEvents: field !== "email" ? "auto" : "none",

        }}
      >
        <Visibility style={{ fontSize: "13px" }} sx={{ color: "#000000" }} />
      </Link>
      {theme && theme?.unSubscribed && (

        <Box
          sx={{
            backgroundColor: "#ffffffff",
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #f1f1f1",
            color: "black",
          }}
        >
          <Unsubscribe
            style={{ fontSize: "13px" }}
            sx={{ color: "#a72e2e" }}
            onClick={() => onCopy(value)}
          />
        </Box>
      )}
    </Stack>
  </Stack>
);

// custom data picker (range)
export const CustomDatePicker = ({ filters, handleFilterChange }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(null);
  const [tempStart, setTempStart] = useState(
    filters?.selectedDates?.startDate || null
  );
  const [tempEnd, setTempEnd] = useState(
    filters?.selectedDates?.endDate || null
  );
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 250,
        width: 200,
      },
    },
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "20%",
    bgcolor: "#f0f0f0ff",
    borderRadius: 2,
    height: "100%",
    maxHeight: "40%",
    boxShadow: 24,
    p: 4,
  };
  const rangeOptions = [
    { label: "None", value: "" },
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 Days", value: "7days" },
    { label: "This Week", value: "thisweek" },
    { label: "Last 15 Days", value: "15days" },
    { label: "This Month", value: "thismonth" },
    { label: "Last 30 Days", value: "30days" },
    { label: "Last 60 Days", value: "60days" },
    { label: "Last 90 Days", value: "90days" },
    { label: "This Year", value: "thisyear" },
    { label: "Custom Range", value: "custom" },
  ];
  function getStyles(currentvalue, selected, theme) {
    return {
      fontWeight:
        selected === currentvalue
          ? theme.typography.fontWeightMedium
          : theme.typography.fontWeightRegular,
    };
  }


  const openPopup = () => {
    setTempStart(filters?.selectedDates?.startDate || null);
    setTempEnd(filters?.selectedDates?.endDate || null);
    setOpen(true);
  };
  const closePopup = () => {
    setOpen(null);
  };

  const applyFilter = () => {
    handleFilterChange("selectedDates", {
      startDate: tempStart,
      endDate: tempEnd,
    });
    closePopup();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl
        size="small"
        sx={{
          minWidth: 180,
          "& .MuiInputLabel-root": {
            fontSize: "0.8rem",
          },
        }}
      >
        <InputLabel id="date-label">Created At</InputLabel>
        <Select
          labelId="date-label"
          id="date"
          value={filters?.range}
          onChange={(e) => {
            handleFilterChange("range", e.target.value);
            if (e.target.value === "custom") {
              openPopup();
            }
          }}
          input={<OutlinedInput label="Created At" />}
          MenuProps={MenuProps}
        >
          {rangeOptions.map(({ label, value }) => (
            <MenuItem
              key={value}
              value={value}
              style={getStyles(value, filters?.range, theme)}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Modal open={open} onClose={closePopup}>
        <Box sx={modalStyle}>
          <Stack direction={"column"} spacing={1}>
            <DatePicker
              sx={{ fontSize: "0.8rem" }}
              className="datepicker startDate-datepicker"
              label="Start Date"
              format="YYYY-MM-DD"
              value={tempStart}
              maxDate={tempEnd || dayjs()} // startDate cannot be after endDate
              onChange={(v) => setTempStart(v)}
              slotProps={{
                field: {
                  // clearable: true,
                  // onClear: () => setTempStart(null),
                  size: "small",
                  sx: { mb: 2 },
                },
              }}
            />

            <DatePicker

              className="datepicker endDate-datepicker"
              label="End Date"
              format="YYYY-MM-DD"
              value={tempEnd}
              minDate={tempStart || null} // endDate cannot be before startDate
              maxDate={dayjs()} // cannot select future dates
              onChange={(v) => setTempEnd(v)}
              slotProps={{
                textField: { size: "small" },
              }}
            />
          </Stack>
          <Stack
            direction={"row"}
            spacing={2}
            justifyContent="flex-endDate"
            mt={2}
          >
            <Button
              size="small"
              variant="contained"
              color="inherit"
              onClick={closePopup}
            >
              Cancel
            </Button>

            <Button size="small" variant="contained" onClick={applyFilter}>
              Apply
            </Button>
          </Stack>

        </Box>
      </Modal>
    </LocalizationProvider>
  );
};
// Gradient Loader
export const GradientLoader = () => (
  <>
    <svg width={0} height={0}>
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#e01cd5" />
          <stop offset="100%" stopColor="#1CB5E0" />
        </linearGradient>
      </defs>
    </svg>

    <CircularProgress sx={{ "svg circle": { stroke: "url(#gradient)" } }} />
  </>
);

// Custom Tooltip
export const CustomTooltip = styled(({ className, styleProps, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, styleProps }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      styleProps?.backgroundColor || theme.palette.commonComponents.white,
    color: styleProps?.color || "#000",
    boxShadow: styleProps?.boxShadow || theme.shadows[10],
    fontSize: styleProps?.fontSize || 11,
  },
}));

// Role Chip Config
const ROLE_STYLE_MAP = {
  main: { label: "Published", bg: "#EBFBEB", color: "#4E8B6E" },
  demo: { label: "Trial", bg: "#FFF5E3", color: "#E7B11C" },
  unpublished: { label: "Draft", bg: "#EEF5FF", color: "#516ECB" },
  development: { label: "Development", bg: "#FDF6F6", color: "#CF4C44" },
};
export const RoleChip = ({ role }) => {
  const key = role?.toLowerCase();
  const cfg = ROLE_STYLE_MAP[key] || {
    label: key,
    bg: "#E5E7EB",
    color: "#374151",
  };
  return (
    <Chip
      label={cfg.label}
      icon={
        <FiberManualRecordIcon color={cfg.bg} style={{ fontSize: "7px" }} />
      }
      size="small"
      sx={{
        fontSize: "10px",
        fontWeight: 500,
        height: "20px",
        backgroundColor: cfg.bg,
        color: cfg.color,
      }}
    />
  );
};

export function formatDate(dateStr, length) {
  const d = new Date(dateStr);

  if (isNaN(d.getTime())) {
    return "";
  }
  const weekday = d.toLocaleDateString("en-IN", { weekday: "short" });
  const day = d.getDate().toString().padStart(2, "0");
  const monthShort = d.toLocaleDateString("en-IN", { month: "short" });
  const year = d.getFullYear();

  let time = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });

  time = time.replace("am", "AM").replace("pm", "PM");

  if (length === "small") {
    return `${monthShort} ${day} ${year}`;
  }

  return `${weekday} ${day} ${monthShort} ${year} ${time} IST`;
}


export const CommonDialog = ({
  openDelDialog,
  handleCloseDelDialog,
  handleDelete,
  delId,
}) => {
  return (
    <Dialog
      key="delete-modal"
      open={openDelDialog}
      keepMounted
      onClose={handleCloseDelDialog}
      aria-describedby="del-dialog-description"
    >
      <DialogTitle>{"Delete this template?"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="del-dialog-description">
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCloseDelDialog}>
          Cancle
        </Button>
        <Button
          variant="contained"
          color="critical"
          onClick={() => handleDelete(delId)}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};